// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container
{
    min-height: 70vh; 
    margin-top: 24px;  
}

.fileContainer {
    border: 1px dashed #FFFFFF33 !important;
    background-color: #101010;
    width: 56.68rem;
    max-width: 56.68rem; /*906px*/
    /* height: 33.93rem; 543px */
    cursor: pointer;
}

.subFile {
    width: 31.9rem;
    height: 15.9rem;
}

.fileContent{
    color:#8B8B8B !important;
    font-family:'Poppins' !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px !important;
}

/* tableComponent */
.tableContainer{
    border: none !important;
    background-color: #101010;
    width: auto;
    min-width: 56.68rem;
    height: 32.56rem;
    cursor: pointer;
}

.tableSection{
    max-height:20.12rem;    
    margin:0px 24px;
    overflow-y: scroll;    
}

.tableSection::-webkit-scrollbar {
    display: none;
}

.tableItems{
    border-bottom: 1px solid #444444;
    display:flex;
    align-items:center;
    justify-content:space-between;  
    margin:0px 24px;
    padding: 12px 0px;
}

.editInput{
    background-color: transparent; 
    border: none;
    outline: none;
    color:white;
    font-family: 'Karla';
    font-weight: 400;
    font-size: 18px; 
    letter-spacing: -0.41px;
    text-transform:capitalize;
}

.headerSection{
    border-bottom:1px solid #444444;
    display:flex !important; 
    justify-content:space-between;
    align-items: center;  
    margin: 20px 20px 0px 20px;
    padding-bottom: 20px;
}

.headText{
    font-family: "Poppins" !important;
    font-weight: 400 !important;
    font-size: 20px !important;
    line-height: 30px !important;
}

.btnText{
    border:1px solid #FFFFFF;
    color:#FFFFFF;
    padding: 10px;
    background-color: transparent;
    color: "#fff" !important;
    font-family: "Karla"!important;
    font-size: 18px!important;
    font-weight: 400;
    line-height: 22px;
    height: 42px;
    border-radius: 5px;
    cursor: pointer;  
    &:active {
        background-color: white !important;
        color: #000000 !important;
    }

}

.submitBtn{
    background-color: #50C878 !important;
    height: 3.93rem;
    width:345px;
    border:none;
    border-radius: 5px;
    font-size: 18px;
    font-family: 'Poppins';
    font-weight: 500;
    color:#000000;
    margin: 20px 0px;
    cursor: pointer;
}

/* image section */
.imageSize{
    height: 80px;
    width: 80px;
    border-radius: 5px;
}

.imageText{
    display: flex;
    align-items: center;
    text-transform:capitalize;
    gap: 14px;    
    font-family: 'Karla' !important;
    font-weight: 500 !important;
    font-size: 18px !important;
    line-height: 22px !important;
    letter-spacing: -0.41px !important;
}

/* gifIconsStyle */
.gifIcons{
    background-color: black;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    z-index: 1000;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
}

.gifIconsImg {
    height: 200px;
    width: 200px;
}

.gifIconsText {
    font-family: 'Poppins' !important;
    font-weight: 500 !important;
    font-size: 32px !important;
    line-height: 22px !important;
    letter-spacing: -0.41px !important;
    }
`, "",{"version":3,"sources":["webpack://./src/components/ui/UploadImageModal/updateImages.css"],"names":[],"mappings":"AAAA;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,eAAe;IACf,mBAAmB,EAAE,QAAQ;IAC7B,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA,mBAAmB;AACnB;IACI,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,aAAa;IACb,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf;QACI,kCAAkC;QAClC,yBAAyB;IAC7B;;AAEJ;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,+BAA+B;IAC/B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA,kBAAkB;AAClB;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,MAAM;IACN,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;IAClC","sourcesContent":[".container\n{\n    min-height: 70vh; \n    margin-top: 24px;  \n}\n\n.fileContainer {\n    border: 1px dashed #FFFFFF33 !important;\n    background-color: #101010;\n    width: 56.68rem;\n    max-width: 56.68rem; /*906px*/\n    /* height: 33.93rem; 543px */\n    cursor: pointer;\n}\n\n.subFile {\n    width: 31.9rem;\n    height: 15.9rem;\n}\n\n.fileContent{\n    color:#8B8B8B !important;\n    font-family:'Poppins' !important;\n    font-weight: 400 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n}\n\n/* tableComponent */\n.tableContainer{\n    border: none !important;\n    background-color: #101010;\n    width: auto;\n    min-width: 56.68rem;\n    height: 32.56rem;\n    cursor: pointer;\n}\n\n.tableSection{\n    max-height:20.12rem;    \n    margin:0px 24px;\n    overflow-y: scroll;    \n}\n\n.tableSection::-webkit-scrollbar {\n    display: none;\n}\n\n.tableItems{\n    border-bottom: 1px solid #444444;\n    display:flex;\n    align-items:center;\n    justify-content:space-between;  \n    margin:0px 24px;\n    padding: 12px 0px;\n}\n\n.editInput{\n    background-color: transparent; \n    border: none;\n    outline: none;\n    color:white;\n    font-family: 'Karla';\n    font-weight: 400;\n    font-size: 18px; \n    letter-spacing: -0.41px;\n    text-transform:capitalize;\n}\n\n.headerSection{\n    border-bottom:1px solid #444444;\n    display:flex !important; \n    justify-content:space-between;\n    align-items: center;  \n    margin: 20px 20px 0px 20px;\n    padding-bottom: 20px;\n}\n\n.headText{\n    font-family: \"Poppins\" !important;\n    font-weight: 400 !important;\n    font-size: 20px !important;\n    line-height: 30px !important;\n}\n\n.btnText{\n    border:1px solid #FFFFFF;\n    color:#FFFFFF;\n    padding: 10px;\n    background-color: transparent;\n    color: \"#fff\" !important;\n    font-family: \"Karla\"!important;\n    font-size: 18px!important;\n    font-weight: 400;\n    line-height: 22px;\n    height: 42px;\n    border-radius: 5px;\n    cursor: pointer;  \n    &:active {\n        background-color: white !important;\n        color: #000000 !important;\n    }\n\n}\n\n.submitBtn{\n    background-color: #50C878 !important;\n    height: 3.93rem;\n    width:345px;\n    border:none;\n    border-radius: 5px;\n    font-size: 18px;\n    font-family: 'Poppins';\n    font-weight: 500;\n    color:#000000;\n    margin: 20px 0px;\n    cursor: pointer;\n}\n\n/* image section */\n.imageSize{\n    height: 80px;\n    width: 80px;\n    border-radius: 5px;\n}\n\n.imageText{\n    display: flex;\n    align-items: center;\n    text-transform:capitalize;\n    gap: 14px;    \n    font-family: 'Karla' !important;\n    font-weight: 500 !important;\n    font-size: 18px !important;\n    line-height: 22px !important;\n    letter-spacing: -0.41px !important;\n}\n\n/* gifIconsStyle */\n.gifIcons{\n    background-color: black;\n    height: 100vh;\n    width: 100vw;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.gifIconsImg {\n    height: 200px;\n    width: 200px;\n}\n\n.gifIconsText {\n    font-family: 'Poppins' !important;\n    font-weight: 500 !important;\n    font-size: 32px !important;\n    line-height: 22px !important;\n    letter-spacing: -0.41px !important;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
